import React, {forwardRef} from 'react';
import {Link} from "react-router-dom";
import ModalTemplate from "../../Wrappers/ModalTemplate";
import CaptainGraphic from '../../../static/images/stories/captain.svg'

const CantLeaveCompanyModal = forwardRef((props, ref) => {
  const handleCloseModal = () => {
    ref.current.closeModal()
  }

  return (
    <ModalTemplate
      ref={ref}
      className="s-center medium"
    >
      <h3>No puedes abandonar la empresa</h3>
      <p className="l-block">Al ser el único propietario es imposible que abandones la empresa.
        Puedes <Link to="/empresa"><a>invitar a
          alguien</a></Link> para que sea propietario o <Link to="/empresa"><a className="s-color-red">eliminar la
          empresa</a></Link></p>
      <div className="l-block">
        <img
          src={CaptainGraphic}
        />
      </div>
      <button className="button" onClick={handleCloseModal}>entendido</button>
    </ModalTemplate>
  );
})

export default CantLeaveCompanyModal;
